import { render, staticRenderFns } from "./IdentityDocumentWithTypeSelectionListView.vue?vue&type=template&id=0b57ec18&scoped=true&"
import script from "./IdentityDocumentWithTypeSelectionListView.vue?vue&type=script&lang=js&"
export * from "./IdentityDocumentWithTypeSelectionListView.vue?vue&type=script&lang=js&"
import style0 from "./IdentityDocumentWithTypeSelectionListView.vue?vue&type=style&index=0&id=0b57ec18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b57ec18",
  null
  
)

export default component.exports